import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

@Controller({ fragment: 'account-create-new-password-fail', component: 'root-layout' })
export default class AccountCreationNewPasswordFailController extends BaseController {

  @OnClick({ target: ['redirect-login-button'] })
  onClickLoginButton(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }
}